import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'

interface Signature {
  Element: HTMLLabelElement
  Args: {
    for: string
    text: string
    helpText?: string
  }
  Blocks: {
    default: []
  }
}

export const FormFieldLabel: TOC<Signature> = <template>
  <label class="cursor-pointer" for={{@for}} ...attributes>
    {{yield}}
    {{@text}}
    {{#if @helpText}}
      <span><PhosphorIcon @icon="phosphor-info-fill" /><Tooltip @text={{@helpText}} /></span>
    {{/if}}
  </label>
</template>

export default FormFieldLabel
